import { render, staticRenderFns } from "./ToxprintsSettings.vue?vue&type=template&id=0d25bc4e"
import script from "./ToxprintsSettings.vue?vue&type=script&setup=true&lang=ts"
export * from "./ToxprintsSettings.vue?vue&type=script&setup=true&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports